export const offerts = [
  {
    name: "Usługa 1",
    isNew: true,
  },
  {
    name: "Usługa 2",
    isNew: false,
  },
  {
    name: "Usługa 3",
    isNew: false,
  },
  {
    name: "Usługa 4",
    isNew: false,
  },
  {
    name: "Usługa 5",
    isNew: false,
  },
  {
    name: "Usługa 6",
    isNew: false,
  },
];
